
import { EnumMicroCategorieActions } from './microCaterogieActions';
//import update from 'react-addons-update';
import update from 'immutability-helper';

const EnumActions = EnumMicroCategorieActions;

const initialState = {

    listMC: [],
    detailsMC: {
        id: null,
        nome: null,
        descrizione: null,
        codQuestionarioQuotazione: null,
        codQuestionarioEmissione: null,
        insertDate: null,
        insertUser: null,
        updateDate: null,
        updateUser: null,
        deleteDate: null,
        deleteUser: null,
        codQuestionarioSinistro: null,
    },
    listProdotti: [],

    listGaranzie: [],

    gruppiRamoSelezionabili: [],
    ramiSelezionabili: [],

    contraenti: [],
    tipoProposta: [],
    tabSelected: 'home-tab',
    ramoSinistri: []

}



const microCategorie = (state, action) => {
    if (typeof state === 'undefined') {
        return initialState
    }

    let moduleName = "[MicroCategorieReducer.js]"
    switch (action.type) {

        case EnumMicroCategorieActions.MC_INITIALIZED:
            return initialState
        case EnumMicroCategorieActions.MC_LIST:
            return Object.assign({}, state, { listMC: action.dati })

        case EnumMicroCategorieActions.MC_DETAILS:
            return Object.assign({}, state, { detailsMC: action.dati })

        case EnumMicroCategorieActions.MC_HANDLE_CHANGE:
            return update(state, {
                detailsMC: { $merge: action.dato }
            });
        case EnumMicroCategorieActions.MC_LIST_PRODOTTI:
            return Object.assign({}, state, { listProdotti: action.dati })
        case EnumMicroCategorieActions.MC_LIST_GARANZIE:
            return Object.assign({}, state, { listGaranzie: action.dati })
        case EnumMicroCategorieActions.MC_UPDATE:
            return update(state, action.microCategorie
            );
        case EnumMicroCategorieActions.MC_RAMO_SINISTRI:
            return Object.assign({}, state, { ramoSinistri: action.ramoSinistri });
        default:
            return state;
    }
}

export default microCategorie;